import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { Link } from '../Link.jsx';
import FieldGroup from '../FieldGroup.jsx';
import { FormError } from '../FormError.jsx';

const SignInForm = (props) => {
  const {
    handleSubmit,
    submitFailed,
    submitError,
    submitting,
    isInModal = false,
  } = props;

  const [showPass, setShowPass] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <Field
        id="email"
        name="email"
        label="Email"
        type="email"
        component={FieldGroup}
      />
      <Field
        id="password"
        name="password"
        label="Password"
        type={showPass ? 'text' : 'password'}
        component={FieldGroup}
      />
      <div className="form-group">
        {!isInModal && <Link route="forgot-password">Forgot password?</Link>}
      </div>
      {submitFailed && <FormError submitError={submitError} />}
      <Button
        block
        bsSize="lg"
        bsStyle="primary"
        disabled={submitting}
        type="submit"
      >
        {submitting ? 'Signing In...' : 'Sign In'}
      </Button>
    </form>
  );
};

export default SignInForm;
